import * as React from 'react';
import { connect } from 'react-redux';
import MFilesTable from './MFilesTable';
import { Dispatch, } from 'redux';
import { AppState } from '../../redux';
import {
    deleteRowbyId,
    mOnFileChange,
    saveTatType,
    saveMessegeOrder,
    onClearAllFiles,
    onSelectFile,
    onSelectAllFile,
    saveManufactType,
    saveBranchType,
    saveDesignApproval,
    onUploadType,
    onClearAllUploaded,
    onRefreshStatus,
    saveDesignSoftware,
    saveOrderModel,
    getLabData, 
    saveLabList,
    saveIsBravo,
    saveDrPreferences,
    saveBookingId
} from 'src/actions/mfileuploadAction';
import { onFileError2, handleCloseRemovefiles } from 'src/actions/errorAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        mfilesUpload: state.mfileupload.mfilesUpload,
        mprogress: state.mfileupload.mprogress,
        msending: state.mfileupload.msending,

        mlabData: state.mfileupload.mlabData,
        mlabChosen: state.mfileupload.mlabChosen,
        mbranchData: state.mfileupload.mbranchData,
        mbranchType: state.mfileupload.mbranchType,

        orderDataTat: state.fileUpload.orderDataTat,
        orderDataManufacturer: state.fileUpload.orderDataManufacturer,

        errorMessage: state.errorState.errorMessage,
        errorBar: state.errorState.errorBar,
        successMessage: state.errorState.successMessage,
        successBar: state.errorState.successBar,

        errorfilemsg: state.errorState.errorfilemsg,
        errorFileUploadedOpen: state.errorState.errorFileUploadedOpen,

        successFileUploadOpen: state.errorState.successFileUploadOpen,
        successfilemsg: state.errorState.successfilemsg,

    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onFilesChange2: function (files2: Array<File>) {
            dispatch(mOnFileChange(files2));
        },
        onFilesError2: function (error: Error, file2: Array<File>) {
            dispatch(onFileError2(error, file2));
        },
        deleteRowbyId: (event: React.ChangeEvent<{ value: string }>) => {
            dispatch(deleteRowbyId(event));
        },
        onUploadAllFiles: () => {
            dispatch(onUploadType);
        },
        onClearAllFiles: () => {
            dispatch(onClearAllFiles);
        },
        onRefreshStatus: () => {
            dispatch(onRefreshStatus);
        },
        onClearAllUploaded: () => {
            dispatch(onClearAllUploaded);
        },
        onSelectFile: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(onSelectFile(event));
        },
        onSelectAllFile: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(onSelectAllFile(event));
        },
        saveTatType: (event: string, index: number) => {
            dispatch(saveTatType(event, index));
        },
        saveManufactType: (event: string, index: number) => {
            dispatch(saveManufactType(event, index));
        },
        saveDesignSoftware: (event: string, index: number) => {
            dispatch(saveDesignSoftware(event, index));
        },
        saveOrderModel: (event: string, index: number) => {
            dispatch(saveOrderModel(event, index));
        },
        saveDesignApproval: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(saveDesignApproval(event));
        },
        saveIsBravo: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(saveIsBravo(event));
        },
        saveBranchType: (branchType: string) => {
            dispatch(saveBranchType(branchType));
        },
        saveLabselected: (branchType: string) => {
            dispatch(saveLabList(branchType));
        },
        saveMessegeOrder: (event: string, index: number) => {
            dispatch(saveMessegeOrder(event, index));
        },
        handleCloseRemovefiles: () => {
            dispatch(handleCloseRemovefiles);
        },
        onComponentDidMount: () => {
            dispatch(getLabData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
        },
         saveDrPreferences: (event: string, index: number) => {
            dispatch(saveDrPreferences(event, index));
        },
        saveBookingId: (event: string, index: number) => {
            dispatch(saveBookingId(event, index));
        },
    };
};

const MFilesTableContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MFilesTable);

export default MFilesTableContainer;



// WEBPACK FOOTER //
// ./src/components/MfilesTable/MFilesTableContainer.tsx